var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"done_button_container",class:{ is_posted: _vm.is_posted }},[_c('a',{staticClass:"button is-info",class:{ 'is-outlined': !_vm.is_posted },on:{"click":_vm.done}},[_vm._v("Done")])])
}
var staticRenderFns = []

export { render, staticRenderFns }